// const connection = io.connect(`${location.protocol}//${location.hostname}:4000/`);
const connection = { 'on': function(){}, 'emit': function(){} };

module.exports = {
	connection
}
